<p>app-select-file works!</p>
